module.exports = __webpack_public_path__ + "img/6.33a63b5e.jpg";